<template>
  <div class="circular-progress">
    <div class="value">
      <slot name="value">{{ $props.valueLabel }}</slot>
    </div>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <linearGradient id="red-gradient" x1="1" y1="0" x2="0" y2="0">
        <stop offset="0%" stop-color="#b10d28"></stop>
        <stop offset="9%" stop-color="#cf1432"></stop>
        <stop offset="25%" stop-color="#ed1a3b"></stop>
        <stop offset="100%" stop-color="#f58220"></stop>
      </linearGradient>
      <linearGradient id="blue-gradient" x1="1" y1="0" x2="0" y2="0">
        <stop offset="0%" stop-color="#2b5585"></stop>
        <stop offset="51%" stop-color="#56ccc7"></stop>
        <stop offset="100%" stop-color="#25d7a6"></stop>
      </linearGradient>
      <circle cx="50" cy="50" r="45" class="circle-back"/>
      <circle cx="50" cy="50" r="45" class="circle-front" transform="rotate(-90,50,50)" :stroke-dashoffset="barProgress" :stroke="`url(#${barVariant})`" :style="{strokeDashoffset: barProgress}"/>
    </svg>
    <div v-if="this.$props.icons" class="bottom-image-description">
      <div>
        <img v-if="this.$props.variant === 'blue'" src="/assets/images/upload.svg" width="19" height="19" alt="upload">
        <img v-if="this.$props.variant === 'red'" src="/assets/images/download.svg" width="19" height="19" alt="download">
      </div>
      <p class="label">{{ $props.label }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'circular-progress',
  data () {
    return {
      barProgress: 283
    }
  },
  props: {
    icons: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ''
    },
    variant: {
      type: String,
      default: 'red',
      validator: (value) => {
        return ['red', 'blue'].includes(value)
      }
    },
    currentValue: {
      type: Number,
      default: 0
    },
    maxValue: {
      type: Number,
      default: 100
    }
  },
  computed: {
    barVariant () {
      return `${this.$props.variant}-gradient`
    }
  },
  methods: {
    calculateBarProgress () {
      const currProgress = (100 * this.$props.currentValue) / this.$props.maxValue // percentage of current progress based on current and max value
      // based on percentage, return the value to match our svg circle path length
      // 283 is rounded value calculated with formula for circle path length -> 2rPi, where r is 45
      return Math.round(283 - 283 * currProgress / 100)
    }
  },
  watch: {
    currentValue () {
      this.barProgress = this.calculateBarProgress()
    },
    maxValue () {
      this.barProgress = this.calculateBarProgress()
    }
  },
  mounted () {
    // add animation on component load
    setTimeout(() => {
      this.barProgress = this.calculateBarProgress()
    }, 10)
  }
}
</script>

<style scoped lang="scss">
.circular-progress {
  svg {
    display: none;
    @media (map_get($breakpoints, sm)) {
      display: block;
    }
  }

  circle {
    fill: transparent;
    stroke-linecap: round;
    transform-origin: 50% 50%;
    transition: stroke-dashoffset 0.6s ease-in-out;
  }

  circle.circle-back {
    stroke: $white;
    stroke-width: 8;
  }

  circle.circle-front {
    fill: transparent;
    stroke-width: 10;
    stroke-linecap: round;
    transform-origin: 50% 50%;
    transform: rotate(-90deg);
    stroke-dashoffset: 283;
    stroke-dasharray: 283;
  }

  .bottom-image-description {
    display: inline-flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin-top: 1rem;

    @media (map_get($breakpoints, sm)) {
      margin-top: 2.4rem;
    }

    .label {
      margin-bottom: 0;
      margin-left: 8px;
      color: $light-black;
      font-size: 1.4rem;
      line-height: 2rem;
      font-weight: 600;
    }
  }
}
</style>
